"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var TTableHeadCell_1 = __importDefault(require("./TTableHeadCell"));
var reorderList_1 = require("./utils/reorderList");
function TTableHeadRow(props) {
    var headerGroups = props.headerGroups, multiSort = props.multiSort, setColumnOrder = props.setColumnOrder, withRowActions = props.withRowActions, modeStyle = props.modeStyle, changeVisibleColumns = props.changeVisibleColumns, visibleSettings = props.visibleSettings;
    var handleDragEndCell = react_1.useCallback(function (headerGroup) { return function (result) {
        if (!result.destination) {
            return;
        }
        var columnOrder = headerGroup.headers.map(function (_) { return _.id; });
        var newColumnOrder = reorderList_1.reorderList(columnOrder, result.source.index, result.destination.index);
        setColumnOrder(newColumnOrder);
    }; }, [setColumnOrder]);
    var renderCloneCell = react_1.useCallback(function (headerGroup) { return function (provided, snapshot, rubric) {
        var col = headerGroup.headers[rubric.source.index];
        return (react_1.default.createElement(TTableHeadCell_1.default, { key: col.id, visibleSettings: visibleSettings, col: col, multiSort: multiSort, draggableProvided: provided, modeStyle: modeStyle, changeVisibleColumns: changeVisibleColumns }));
    }; }, [multiSort]);
    var getContainerForClone = react_1.useCallback(function () { return document.getElementById('droppable-row'); }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, headerGroups.map(function (headerGroup) {
        return visibleSettings.isWithDraggableColumns ? (react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { key: headerGroup.id || 'dragDropContext', onDragEnd: handleDragEndCell(headerGroup) },
            react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "droppable", direction: "horizontal", renderClone: renderCloneCell(headerGroup), 
                //@ts-ignore тут ошибка, не корректно описан тип, игнорируем умышленно
                getContainerForClone: getContainerForClone }, function (droppableProvided) { return (react_1.default.createElement(core_1.TableRow, __assign({ id: "droppable-row" }, headerGroup.getHeaderGroupProps(), droppableProvided.droppableProps, { ref: droppableProvided.innerRef }),
                headerGroup.headers.map(function (col, index) { return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { draggableId: col.id, index: index, key: col.id }, function (provided) { return (react_1.default.createElement(TTableHeadCell_1.default, { visibleSettings: visibleSettings, key: col.id, col: col, multiSort: multiSort, draggableProvided: provided, modeStyle: modeStyle, changeVisibleColumns: changeVisibleColumns })); })); }),
                droppableProvided.placeholder,
                withRowActions ? react_1.default.createElement(core_1.TableCell, { align: "right" }) : null)); }))) : (react_1.default.createElement(core_1.TableRow, __assign({ id: "droppable-row" }, headerGroup.getHeaderGroupProps()),
            headerGroup.headers.map(function (col, index) { return (react_1.default.createElement(TTableHeadCell_1.default, { key: col.id, visibleSettings: visibleSettings, col: col, multiSort: multiSort, modeStyle: modeStyle, changeVisibleColumns: changeVisibleColumns })); }),
            withRowActions ? react_1.default.createElement(core_1.TableCell, { align: "right" }) : null));
    })));
}
exports.default = TTableHeadRow;
